import React from "react";
import {Button} from "reactstrap";
import Framework from "@beardeddevops/react.framework";

class EditableNotesCell extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: props.originalValue || '',
			isEditing: false
		};
	}

	handleChange = (e) => {
		if (this.props.rootState.user !== null) return;
		this.setState({
			value: e.target.value,
			isEditing: e.target.value !== this.props.originalValue
		});
	}

	handleSave = () => {
		this.props.onSave(this.props.rowId, this.state.value);
		this.setState({ isEditing: false });
	}

	handleCancel = () => {
		this.setState({
			value: this.props.originalValue || '',
			isEditing: false
		});
	}

	render() {
		const isEditable = this.props.rootState.user === null;
		return (
			<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
				<input
					type="text"
					value={this.state.value}
					onChange={this.handleChange}
					placeholder={isEditable ? "Click to add notes..." : "No notes"}
					readOnly={!isEditable}
					style={{
						border: 'none',
						background: 'transparent',
						flex: 1,
						padding: '4px',
						fontSize: 'inherit',
						minWidth: 0,
						cursor: isEditable ? 'text' : 'default',
						opacity: isEditable ? 1 : 0.7
					}}
				/>
				{this.state.isEditing && isEditable && (
					<div style={{ display: 'flex', gap: '4px', marginLeft: '8px' }}>
						<Button
							color="success"
							size="sm"
							onClick={this.handleSave}
							style={{ fontSize: '10px', padding: '2px 6px' }}
						>
							✓
						</Button>
						<Button
							color="secondary"
							size="sm"
							onClick={this.handleCancel}
							style={{ fontSize: '10px', padding: '2px 6px' }}
						>
							✕
						</Button>
					</div>
				)}
			</div>
		);
	}
}

export default Framework.Components.withRootState(EditableNotesCell)
